import { RouteType } from "types/RouteType";
import ReposStore from "./ReposStore";

const reposRoute: RouteType[] = [
  {
    // The route name and the header title are the same word on purpose: the
    // nav, the omnibar and the page must agree on what this page is called.
    // (It was "Repos" in the nav and "Repositories" on the page.)
    name: "Repositories",
    path: "/devops/repos",
    layout: "/app",
    viewportCard: {
      header: {
        enableBackButton: true,
        title: "Repositories",
        enableRefreshButton: true,
        component: () => import("./Repos.Header"),
      },
      body: {
        component: () => import("./Repos.Body"),
        grayBackground: true,
      },
    },
    group: "DevOps",
    // "repos" stays an alias so the old nav word still finds the page.
    searchAliases: ["git", "source code", "repos"],
    // Entirely read-only (repos, branches, active PRs). Reads require
    // authentication only (viewer+); the API enforces the read gate.
    requiresAuth: true,
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const store = rootStore.devopsReposViewStore as ReposStore;
      store?.initialize();
    },
    // Mirrors Pipelines: the store's teardown seam on leave (today it closes
    // the pull-request drill-in; a live feed lands here when it exists).
    onExit: ({ rootStore }) => {
      const store = rootStore.devopsReposViewStore as ReposStore;
      store?.dispose();
    },
  },
];

export default reposRoute;
